import "./NavBar.scss";

const NavBar = () => {
  return (
    <div className="nav-bar">
      <h2 className="nav-bar__heading">Wordle</h2>
    </div>
  );
};

export default NavBar;
